const CATEGORIESENGINEERS: {
  label: string;
  slug: string;
  description: string;
}[] = [
  {
    label: 'All',
    slug: 'latest',
    description: '',
  },
  {
    label: 'Engineering careers',
    slug: 'engineering-careers',
    description: 'Advice, tips and best practices for finding a role and making a big impact.',
  },
  {
    label: 'Remote how-to’s',
    slug: 'remote-how-tos',
    description: 'Collaborate, communicate, and build trust on your remote team. Learn how.',
  },
  {
    label: 'CTO perspectives',
    slug: 'cto-perspectives',
    description: 'What leaders look for when hiring global talent & how they built their careers.',
  },
  {
    label: 'Level up your code',
    slug: 'level-up-your-code',
    description: 'Developers share the tools and skills needed to build amazing products.',
  },
  {
    label: 'Tech Talks',
    slug: 'tech-talks',
    description:
      'This educational series brings you world-renowned tech leaders, who joined us on the Terminal stage to share hard-earned insights on the topics that matter to you.',
  },
];

export default CATEGORIESENGINEERS;
